import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/sass/affiliate.scss";
import { END_POINT } from "../../constants/defaultValues";

const AffiliateLogin = ({ history }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${END_POINT}/api/affiliate/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("affiliate_token", data.token);
        localStorage.setItem("affiliate_user", JSON.stringify(data.user));
        history.push("/dashboard");
      } else {
        setError(data.responseText || "Đăng nhập thất bại");
      }
    } catch (err) {
      console.error(err);
      setError("Lỗi kết nối server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aff-auth-page">
      <div className="aff-auth-wrapper">
        <div className="aff-auth-card">
          <div className="aff-auth-logo">
            <img
              src="/assets/img/logo-horizontal.svg"
              alt="VMASS Affiliate"
              style={{ height: "40px" }}
            />
          </div>

          <div className="aff-auth-header">
            <h1 className="aff-auth-title">Chào mừng trở lại!</h1>
            <p className="aff-auth-subtitle">
              Đăng nhập để quản lý chiến dịch và theo dõi thu nhập của bạn
            </p>
          </div>

          {error && (
            <div className="aff-auth-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="aff-auth-form">
            <div className="aff-auth-field">
              <label className="aff-auth-label">📧 Email</label>
              <input
                type="email"
                className="aff-auth-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="name@example.com"
              />
            </div>

            <div className="aff-auth-field">
              <label className="aff-auth-label">🔒 Mật khẩu</label>
              <input
                type="password"
                className="aff-auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
              />
              <div className="text-right mt-1">
                <Link
                  to="/forgot-password"
                  style={{ fontSize: "13px", color: "#64748b" }}
                >
                  Quên mật khẩu?
                </Link>
              </div>
            </div>

            <button type="submit" disabled={loading} className="aff-auth-btn">
              {loading ? (
                <span className="aff-auth-spinner"></span>
              ) : (
                "Đăng nhập →"
              )}
            </button>
          </form>

          <div className="aff-auth-footer">
            <span>Chưa có tài khoản? </span>
            <Link to="/signup" className="aff-auth-link">
              Đăng ký ngay
            </Link>
          </div>

          <div className="aff-auth-features">
            <span>✓ Miễn phí 100%</span>
            <span>✓ Hoa hồng 20%</span>
            <span>✓ Rút tiền nhanh</span>
          </div>
        </div>

        <Link to="/" className="aff-auth-back">
          ← Quay lại trang chủ
        </Link>
      </div>
    </div>
  );
};

export default AffiliateLogin;
